/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 9 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import { HiOutlineLocationMarker } from "react-icons/hi";
import Lottie from "lottie-react";
import DisLike from "../JSONFile/dislike.json";
import Like from "../JSONFile/like.json";
import { MyContext } from "../Context/MyProvider";
import axios from "axios";
import Crown from "../Icon/crown-alt.png";
import { useTranslation } from "react-i18next";
import UserChat from "./UserChat";
import HeartIcon from "../Icon/heartRed.svg";
import ChatIcon from "../Icon/chat.svg";
import GiftIcon from "../Icon/gift.svg";
import { showTost } from "../showTost";
import Slider from "react-slick";
import LodingLottie from "../Lodinglottie";
import GiftModal from "./GiftModal";
import EngagementModal from "./EngagementModal";
import { FaStar, FaBolt } from "react-icons/fa";
import { emitProfileAction } from "../socket";
import PageHeader from "./PageHeader";
import { FiCompass } from "react-icons/fi";
import { fetchProfileCompletion, getChatBlockMessage, getDiscoveryBlockMessage } from "../utils/profileCompletion";
import {
  defaultSearchPreferenceOptions,
  fetchGenderOptions,
} from "../utils/genderOptions";
import {
  defaultDistanceSettings,
  fetchDistanceSettings,
} from "../utils/distanceSettings";
import {
  defaultAgeSettings,
  fetchAgeSettings,
} from "../utils/ageSettings";

const calculateDistanceKm = (lat1, lon1, lat2, lon2) => {
  const p1Lat = parseFloat(lat1);
  const p1Lon = parseFloat(lon1);
  const p2Lat = parseFloat(lat2);
  const p2Lon = parseFloat(lon2);
  if (isNaN(p1Lat) || isNaN(p1Lon) || isNaN(p2Lat) || isNaN(p2Lon)) return 99999;
  if ((p1Lat === 0 && p1Lon === 0) || (p2Lat === 0 && p2Lon === 0)) return 99999;
  const R = 6371;
  const dLat = ((p2Lat - p1Lat) * Math.PI) / 180;
  const dLon = ((p2Lon - p1Lon) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((p1Lat * Math.PI) / 180) *
      Math.cos((p2Lat * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const clampedA = Math.min(1, Math.max(0, a));
  const c = 2 * Math.atan2(Math.sqrt(clampedA), Math.sqrt(1 - clampedA));
  return Math.round(R * c * 10) / 10;
};

const ProfileCardSkeleton = () => (
  <div className="custom-card card-rounded-1 relative rounded-[2.5rem] pb-2 min-w-0 w-full overflow-hidden bg-slate-100 border border-slate-200/80 shadow-xs h-[420px] flex flex-col justify-between p-5">
    <div className="flex justify-between items-center z-10">
      <div className="w-20 h-7 rounded-full shimmer-card"></div>
      <div className="w-14 h-7 rounded-full shimmer-card"></div>
    </div>
    
    <div className="space-y-3 z-10">
      <div className="w-3/4 h-6 rounded-lg shimmer-card"></div>
      <div className="w-1/2 h-4 rounded-md shimmer-card"></div>
      
      <div className="flex justify-center items-center gap-2 pt-3">
        <div className="w-11 h-11 rounded-full shimmer-card"></div>
        <div className="w-11 h-11 rounded-full shimmer-card"></div>
        <div className="w-11 h-11 rounded-full shimmer-card"></div>
        <div className="w-11 h-11 rounded-full shimmer-card"></div>
        <div className="w-11 h-11 rounded-full shimmer-card"></div>
      </div>
    </div>
  </div>
);

const Dashboard = () => {
  const { t } = useTranslation();
  const {
    basUrl,
    setProfileId,
    imageBaseURL,
    setDetails,
    setBlockId,
    setChatId,
    chatId,
    setChatUserName,
    setCurrency,
    isSuperLikeMasterEnabled,
    isBoostMasterEnabled,
  } = useContext(MyContext);

  const navigate = useNavigate();

  const [api, setApi] = useState([]);
  const [allProfiles, setAllProfiles] = useState([]);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [preference, setPreference] = useState("");
  const [distance, setDistance] = useState(defaultDistanceSettings.defaultDistance);
  const [distanceSettings, setDistanceSettings] = useState(defaultDistanceSettings);
  const [ageSettings, setAgeSettings] = useState(defaultAgeSettings);
  const [agemin, setAgemin] = useState(defaultAgeSettings.defaultMinAge);
  const [agemax, setAgemax] = useState(defaultAgeSettings.defaultMaxAge);
  const [isVisible, setIsVisible] = useState(false);
  const [isEngagementOpen, setIsEngagementOpen] = useState(false);
  const [engagementInitialType, setEngagementInitialType] = useState("SUPER_LIKE");
  const [interestId, setInterestId] = useState([]);
  const [language, setLanguage] = useState([]);
  const [religion, setReligion] = useState("");
  const [relationship, setRelationship] = useState("");
  const [verify, setVerify] = useState("");
  const [close, setClose] = useState([]);
  const [bg, setBg] = useState([]);
  const [like, setLike] = useState([]);
  const [likeDn, setLikeDn] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lazyLoading, setLazyLoading] = useState(false);
  const [userCoords, setUserCoords] = useState({ lat: null, long: null });
  const [completionBlockMessage, setCompletionBlockMessage] = useState("");
  const [searchPreferenceOptions, setSearchPreferenceOptions] = useState(defaultSearchPreferenceOptions);
  const completionRedirectRef = useRef(false);

  const getLat = useCallback(() => {
    const isPassportActive = localStorage.getItem("saved_passport_active") === "true";
    if (isPassportActive) {
      const pLat = localStorage.getItem("saved_passport_lat");
      if (pLat) return pLat;
    }
    if (userCoords.lat) return String(userCoords.lat);
    try {
      const filter = JSON.parse(localStorage.getItem("FilterData") || "{}");
      if (filter.lats) return String(filter.lats);
    } catch {}
    return "0";
  }, [userCoords.lat]);

  const getLong = useCallback(() => {
    const isPassportActive = localStorage.getItem("saved_passport_active") === "true";
    if (isPassportActive) {
      const pLong = localStorage.getItem("saved_passport_long");
      if (pLong) return pLong;
    }
    if (userCoords.long) return String(userCoords.long);
    try {
      const filter = JSON.parse(localStorage.getItem("FilterData") || "{}");
      if (filter.longs) return String(filter.longs);
    } catch {}
    return "0";
  }, [userCoords.long]);

  const isPassportActive = localStorage.getItem("saved_passport_active") === "true";
  const passportLocationName = localStorage.getItem("saved_passport_location_name") || "Passport Location";
  const passportRadius = parseFloat(localStorage.getItem("rediuse") || "50");

  const handleResetPassportLocation = async () => {
    const uid = getUserId();
    if (uid) {
      axios.post(`${basUrl}clear_passport_location`, { uid }).catch(console.error);
    }
    localStorage.removeItem("saved_passport_active");
    localStorage.removeItem("saved_passport_lat");
    localStorage.removeItem("saved_passport_long");
    localStorage.removeItem("saved_passport_location_name");
    showTost({ title: "Location reset to your real GPS!" });
    fetchUserData();
  };

  const displayCards = api;

  const [giftReceiverId, setGiftreceiverId] = useState();
  const [interestList, setInterestList] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [relationshipList, setRelationshipList] = useState([]);
  const [filterinclude, setFilterinclude] = useState();
  const [directchat, setDirectchat] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndex2, setCurrentIndex2] = useState(0);
  const [totalCards, setTotalCards] = useState(0);

  const MIN_AGE = 18;
  const MAX_AGE = 70;
  const ageSpan = MAX_AGE - MIN_AGE;

  const currentMinAge = Math.min(Math.max(Number(agemin) || MIN_AGE, MIN_AGE), MAX_AGE);
  const currentMaxAge = Math.min(Math.max(Number(agemax) || MAX_AGE, MIN_AGE), MAX_AGE);

  const AGEMIN = currentMinAge;
  const AGEMAX = currentMaxAge;

  const minAgeRatio = Math.max(0, Math.min(1, (currentMinAge - MIN_AGE) / ageSpan));
  const maxAgeRatio = Math.max(0, Math.min(1, (currentMaxAge - MIN_AGE) / ageSpan));

  const minGradientPos = `calc(10px + (100% - 20px) * ${minAgeRatio})`;
  const maxGradientPos = `calc(10px + (100% - 20px) * ${maxAgeRatio})`;

  const Classadd = useRef();
  const BgDisplay = useRef();
  const fetchedRef = useRef(false);
  
  const percent = ((Number(distance) - distanceSettings.minDistance) / (distanceSettings.maxDistance - distanceSettings.minDistance)) * 100;

  const sliderStyle = {
    background: `linear-gradient(to right, rgba(152,14,255,255) ${percent}%, rgba(199, 197, 197, 0.801) ${percent}%)`,
  };

  const removeProfileFromHome = useCallback((profileId) => {
    if (!profileId) return;
    setAllProfiles((prev) => prev.filter((card) => String(card.profile_id) !== String(profileId)));
    setApi((prevCards) => {
      const nextCards = prevCards.filter((card) => String(card.profile_id) !== String(profileId));
      if (nextCards.length !== prevCards.length) {
        setTotalCards((prev) => Math.max(0, prev - (prevCards.length - nextCards.length)));
        setProfileId(nextCards.length > 0 ? nextCards[nextCards.length - 1].profile_id : null);
      }
      return nextCards;
    });
  }, [setProfileId]);

  const settings2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const getUserId = () => {
    try {
      return JSON.parse(localStorage.getItem("Register_User") || "{}").id;
    } catch {
      return null;
    }
  };

  useEffect(() => {
    fetchGenderOptions(basUrl).then(({ searchPreferenceOptions }) => {
      setSearchPreferenceOptions(searchPreferenceOptions);
    });
    fetchDistanceSettings(basUrl).then((settings) => {
      setDistanceSettings(settings);
      setDistance((current) => {
        const parsed = Number(current);
        if (Number.isFinite(parsed) && parsed > 0) {
          return Math.min(Math.max(parsed, settings.minDistance), settings.maxDistance);
        }
        return settings.defaultDistance;
      });
    });
    fetchAgeSettings(basUrl).then((settings) => {
      setAgeSettings(settings);
      try {
        const filterData = localStorage.getItem("FilterData");
        if (filterData) {
          const filter = JSON.parse(filterData);
          if (filter.minage && !isNaN(Number(filter.minage))) setAgemin(Number(filter.minage));
          if (filter.maxage && !isNaN(Number(filter.maxage))) setAgemax(Number(filter.maxage));
          return;
        }
      } catch {}
      setAgemin((current) => {
        const parsed = Number(current);
        if (Number.isFinite(parsed) && parsed >= settings.minAge && parsed <= settings.maxAge) {
          return parsed;
        }
        return settings.defaultMinAge;
      });
      setAgemax((current) => {
        const parsed = Number(current);
        if (Number.isFinite(parsed) && parsed >= settings.minAge && parsed <= settings.maxAge) {
          return parsed;
        }
        return settings.maxAge || 70;
      });
    });
  }, [basUrl]);

  const hasActiveFilterData = useCallback(() => {
    try {
      const rawFilter = localStorage.getItem("FilterData");
      if (!rawFilter || rawFilter === "null" || rawFilter === "undefined") return false;
      const parsed = JSON.parse(rawFilter);
      return Boolean(parsed && typeof parsed === "object" && parsed.uid);
    } catch {
      localStorage.removeItem("FilterData");
      return false;
    }
  }, []);

  const FilterHandler = useCallback(() => {
    if (open) {
      Classadd.current.classList.remove("open");
      BgDisplay.current.style.display = "none";
      document.body.classList.remove("no-scrollbody");
      document.documentElement.classList.remove("no-scrollbody");
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    } else {
      Classadd.current.classList.add("open");
      BgDisplay.current.style.display = "block";
      document.body.classList.add("no-scrollbody");
      document.documentElement.classList.add("no-scrollbody");
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    }
    setOpen(!open);
    setOpen2(!open2);
  }, [open, open2]);


  const toggleSelection = (list, setList, id, maxLen = 5) => {
    if (list.includes(id)) {
      setList(list.filter((el) => el !== id));
    } else if (list.length < maxLen) {
      setList([...list, id]);
    }
  };

  const InterestMapHandler = (id) =>
    toggleSelection(interestId, setInterestId, id);
  const LanguageMapHandler = (id) => toggleSelection(language, setLanguage, id);

  const IdHandler = (i, profile_id, name) => {
    const title = name.replace(/\s+/g, "_").toLowerCase();
    sessionStorage.setItem("ExploreDetailSource", "Discover");
    sessionStorage.setItem("ExploreDetailSuperLike", "0");
    navigate(`/detail/${title}`, {
      state: { ProfileId: profile_id, sourceTab: "Discover" },
    });
    setDetails(i);
    setBlockId(profile_id);
    sessionStorage.setItem("DetailsId", profile_id);
  };

  const handleAnimationAction = (
    id,
    name,
    action,
    listSetter,
    finishSetter,
  ) => {
    const uid = getUserId();
    listSetter((prev) => [...prev, id]);
    setTimeout(() => {
      finishSetter((prev) => [...prev, name]);
    }, 1600);

    const fallback = (payload = {}) => axios.post(`${basUrl}like_dislike`, {
      uid,
      profile_id: id,
      action,
      client_action_id: payload.client_action_id,
    });
    emitProfileAction({ profileId: id, action, fallback })
      .then((res) => {
        showTost({ title: res?.data?.ResponseMsg || "Action Recorded!" });
        removeProfileFromHome(id);
      })
      .catch((error) => {
        listSetter((prev) => prev.filter((item) => String(item) !== String(id)));
        finishSetter((prev) => prev.filter((item) => String(item) !== String(name)));
        showTost({ title: error.message || "Action failed!" });
      });
  };

  const CloseAnimationHandler = (id, name) =>
    handleAnimationAction(id, name, "UNLIKE", setClose, setBg);
  const LikeAnimationHandler = (id, name) =>
    handleAnimationAction(id, name, "LIKE", setLike, setLikeDn);

  const SuperLikeAnimationHandler = async (id, name) => {
    const uid = getUserId();
    if (!uid) {
      showTost({ title: "Please log in first!" });
      return;
    }

    try {
      const token = localStorage.getItem("token") || "";
      const headers = { authorization: token ? `Bearer ${token}` : "" };
      const cleanBaseUrl = (basUrl || "").trim().replace(/\/+$/, "");
      const base = cleanBaseUrl.toLowerCase().endsWith("/api") ? cleanBaseUrl.slice(0, -4) : cleanBaseUrl;
      const url = `${base}/api/use_super_like`;

      const res = await axios.post(url, { uid, target_uid: id }, { headers });
      if (res.data.Result === "true") {
        showTost({ title: `Super Liked ${name}!` });
        setLike((prev) => [...prev, id]);
        setTimeout(() => {
          setLikeDn((prev) => [...prev, name]);
        }, 1600);
        removeProfileFromHome(id);
      } else {
        showTost({ title: res.data.ResponseMsg || "No Super Likes left! Recharge now." });
        setEngagementInitialType("SUPER_LIKE");
        setIsEngagementOpen(true);
      }
    } catch (err) {
      setEngagementInitialType("SUPER_LIKE");
      setIsEngagementOpen(true);
    }
  };

  useEffect(() => {
    const handleProfileActionRecorded = (event) => {
      const profileId = event.detail?.profileId;
      if (!profileId) return;
      removeProfileFromHome(profileId);
    };

    window.addEventListener("gomeet:profile-action-recorded", handleProfileActionRecorded);
    return () => {
      window.removeEventListener("gomeet:profile-action-recorded", handleProfileActionRecorded);
    };
  }, [removeProfileFromHome]);

  const fetchUserData = useCallback(async () => {
    try {
      const uid = getUserId();
      if (!uid) return;
      setLoading(true);
      const completion = await fetchProfileCompletion(basUrl, uid);
      const blockMessage = getDiscoveryBlockMessage(completion);
      if (blockMessage) {
        setCompletionBlockMessage(blockMessage);
        setApi([]);
        setAllProfiles([]);
        setTotalCards(0);
        showTost({ title: blockMessage });
        if (!completionRedirectRef.current) {
          completionRedirectRef.current = true;
          navigate("/profile", {
            state: {
              profileCompletionRequired: true,
              missingTasks: completion?.missing_tasks || [],
            },
          });
        }
        return;
      }
      completionRedirectRef.current = false;
      setCompletionBlockMessage("");
      const response = await axios.post(`${basUrl}home_data`, {
        uid,
        lats: getLat(),
        longs: getLong(),
        radius_search: localStorage.getItem("rediuse") || "5000",
      });
      if (response.data.Result === "true") {
        const profileList = response.data.profilelist || [];
        setAllProfiles(profileList);
        setTotalCards(profileList.length);
        if (!hasActiveFilterData()) {
          setApi(profileList.slice(0, 12));
          setCurrentIndex(0);
        }
        setProfileId(
          profileList.length > 0
            ? profileList[profileList.length - 1].profile_id
            : null,
        );
        setCurrency(response.data.currency);
        setFilterinclude(response.data.filter_include);
        setDirectchat(response.data.direct_chat);
        localStorage.setItem("Profile_ratio", response.data.profile_percentage);
        localStorage.setItem("PurchaseId", response.data.plan_id);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      setLazyLoading(false);
    }
  }, [basUrl, getLat, getLong, hasActiveFilterData, navigate, setCurrency, setProfileId]);

  const handleScroll = useCallback(() => {
    if (loading || lazyLoading) return;
    const ScrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    const ScrollHeight =
      document.documentElement.scrollHeight || document.body.scrollHeight;
    const clientHeight =
      document.documentElement.clientHeight || document.body.clientHeight;
    const clientHeight2 = window.innerHeight;

    const isAtBottom =
      window.innerWidth < 430
        ? ScrollTop + clientHeight2 >= ScrollHeight - 250
        : ScrollTop + clientHeight >= ScrollHeight - 250;

    if (isAtBottom && api.length < totalCards && allProfiles.length > api.length) {
      setLazyLoading(true);
      setTimeout(() => {
        setApi((prev) => {
          const nextIndex = prev.length + 12;
          return allProfiles.slice(0, nextIndex);
        });
        setLazyLoading(false);
      }, 250);
    }
  }, [allProfiles, api.length, lazyLoading, loading, totalCards]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("touchmove", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("touchmove", handleScroll);
    };
  }, [handleScroll]);

  const FilterResetHandler = async () => {
    FilterHandler();
    setLoading(true);
    setApi([]);
    setCurrentIndex(0);
    setCurrentIndex2(0);
    setTotalCards(0);
    setDistance(distanceSettings.defaultDistance);
    setAgemin(ageSettings.defaultMinAge);
    setAgemax(ageSettings.defaultMaxAge);
    setPreference("");
    setInterestId([]);
    setLanguage([]);
    setReligion("");
    setRelationship("");
    setVerify("");
    localStorage.removeItem("FilterData");
    showTost({ title: "Filter Reset Successfully!!" });
    fetchUserData();
  };

  const FilterApplyHandler = async () => {
    const uid = getUserId();
    if (!uid) return;

    FilterHandler();
    setLoading(true);

    const FilterData = {
      uid,
      radius_search: Number(distance).toFixed(2),
      search_preference: preference || "0",
      lats: getLat(),
      longs: getLong(),
      minage: String(agemin),
      maxage: String(agemax),
      relation_goal: relationship || "0",
      interest: interestId.length > 0 ? interestId.join(",") : "0",
      religion: religion || "0",
      language: language.length > 0 ? language.join(",") : "0",
      is_verify: verify || "0",
    };

    localStorage.setItem("FilterData", JSON.stringify(FilterData));
    FilterDataGetHandler(0);
  };

  const FilterDataGetHandler = useCallback(async (id) => {
    try {
      currentIndex2 <= 0 ? setLoading(true) : setLazyLoading(true);

      const uid = getUserId();
      const filterData = localStorage.getItem("FilterData");

      if (!uid || !filterData) return;
      let filter;
      try {
        filter = JSON.parse(filterData);
      } catch {
        localStorage.removeItem("FilterData");
        setApi([]);
        return;
      }
      if (!filter?.uid) {
        localStorage.removeItem("FilterData");
        setApi([]);
        return;
      }

      const response = await axios.post(`${basUrl}filter`, {
        uid,
        radius_search: filter.radius_search,
        search_preference: filter.search_preference,
        lats: getLat(),
        longs: getLong(),
        minage: filter.minage,
        maxage: filter.maxage,
        relation_goal: filter.relation_goal,
        interest: filter.interest,
        religion: filter.religion,
        language: filter.language,
        is_verify: filter.is_verify,
      });

      if (response.data.Result === "true") {
        const profileList = response.data.profilelist || [];
        setAllProfiles(profileList);
        setTotalCards(profileList.length);
        setApi(profileList.slice(0, 12));
        setCurrentIndex2(0);

        if (id) {
          showTost({ title: response.data.ResponseMsg });
        }
      } else {
        setAllProfiles([]);
        setApi([]);
        setTotalCards(0);
        if (id) {
          showTost({ title: response.data.ResponseMsg || "No profiles found." });
        }
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    } finally {
      setLoading(false);
      setLazyLoading(false);
    }
  }, [basUrl, currentIndex2, getLat, getLong]);

  const GetHandler = useCallback(() => {
    axios.post(`${basUrl}interest`).then((res) => {
      setInterestList(res.data.interestlist);
    });
    axios.post(`${basUrl}languagelist`).then((res) => {
      setLanguageList(res.data.languagelist);
    });
    axios.post(`${basUrl}religionlist`).then((res) => {
      setReligionList(res.data.religionlist);
    });
    axios.post(`${basUrl}goal`).then((res) => {
      setRelationshipList(res.data.goallist);
    });
  }, [basUrl]);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setUserCoords({ lat: pos.coords.latitude, long: pos.coords.longitude });
      },
      (err) => console.warn("Location error:", err),
      { enableHighAccuracy: true },
    );

    if (hasActiveFilterData()) {
      FilterDataGetHandler("");
    } else {
      fetchUserData();
    }
  }, [fetchUserData, FilterDataGetHandler, hasActiveFilterData]);

  useEffect(() => {
    GetHandler();
  }, [GetHandler]);

  const ChatHandler = async (UserId, name) => {
    const uid = getUserId();
    const completion = await fetchProfileCompletion(basUrl, uid);
    const chatBlockMessage = getChatBlockMessage(completion);
    if (chatBlockMessage) {
      showTost({ title: chatBlockMessage });
      navigate("/profile", {
        state: {
          profileCompletionRequired: true,
          missingTasks: completion?.missing_tasks || [],
        },
      });
      return;
    }

    if (directchat === "1") {
      setChatId(UserId);
      sessionStorage.setItem("DetailsId", UserId);
      setChatUserName(name);
      navigate("/chat", { state: { ProfileId: UserId, name: name } });
    } else {
      showTost({ title: "No Direct Chat any User" });
      navigate("/upgrade");
    }
  };

  const ChatCloseHandle = () => {
    setChatId("");
    sessionStorage.setItem("ChatId", "");
  };

  return (
    <>
      <div style={{ userSelect: "none", cursor: "default" }}>
        {displayCards.length > 0 ? (
          <div className="main-wrapper bg-[#e5e5e5] dashboard">
            <div className="content-body ">
              <div className="container-fluid my-2 sm:my-4 px-2.5 sm:px-4">
                <div className="row">
                  <div className="col-xl-12">
                    <PageHeader
                      title={t("Find Your Match")}
                      subtitle={t("Discover verified profiles matching your preferences nearby")}
                      breadcrumbs={[{ label: t("Home") }]}
                      icon={FiCompass}
                      actions={
                        <div className="flex items-center gap-2 flex-wrap">
                          {isPassportActive && (
                            <div className="flex items-center gap-2 bg-purple-50 border border-purple-200 px-3 py-1.5 rounded-full shadow-xs">
                              <span className="text-xs font-bold text-purple-800 truncate max-w-[220px]">
                                📍 {passportLocationName} ({Math.round(passportRadius)} km)
                              </span>
                              <button
                                onClick={handleResetPassportLocation}
                                className="text-xs bg-purple-600 hover:bg-purple-700 text-white font-bold px-2.5 py-1 rounded-full transition-all shrink-0 cursor-pointer"
                                title="Reset location to real GPS"
                              >
                                {t("Reset Location")}
                              </button>
                            </div>
                          )}
                          {String(filterinclude) === "1" &&
                            (hasActiveFilterData() ? (
                              <button
                                onClick={() => FilterResetHandler(1)}
                                className="btn gap-1 df-center text-white font-semibold rounded-xl px-4 py-2 text-sm shadow-xs transition-all cursor-pointer"
                                id="toggleFilterBtn"
                                style={{ background: "rgb(152, 14, 255)" }}
                              >
                                <svg
                                  width="15"
                                  height="10"
                                  viewBox="0 0 15 10"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="mx-1"
                                >
                                  <path
                                    d="M6.15855 9.96157H9.3457V8.368H6.15855V9.96157ZM0.581055 0.400146V1.99372H14.9232V0.400146H0.581055ZM2.97141 5.97765H12.5328V4.38407H2.97141V5.97765Z"
                                    fill="white"
                                  ></path>
                                </svg>
                                {t("Reset")}
                              </button>
                            ) : (
                              <button
                                onClick={FilterHandler}
                                className="btn gap-1 df-center text-white font-semibold rounded-xl px-4 py-2 text-sm shadow-xs transition-all cursor-pointer"
                                id="toggleFilterBtn"
                                style={{ background: "rgb(152, 14, 255)" }}
                              >
                                <svg
                                  width="15"
                                  height="10"
                                  viewBox="0 0 15 10"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="mx-1"
                                >
                                  <path
                                    d="M6.15855 9.96157H9.3457V8.368H6.15855V9.96157ZM0.581055 0.400146V1.99372H14.9232V0.400146H0.581055ZM2.97141 5.97765H12.5328V4.38407H2.97141V5.97765Z"
                                    fill="white"
                                  ></path>
                                </svg>
                                {t("Filter")}
                              </button>
                            ))}
                        </div>
                      }
                    />
                  </div>
                  <div className="col-xl-12">
                    <div className="">
                      <div className="grid grid-cols-4 p-[16px] card card-rounded grid-transition grid-responsive ">
                        {displayCards.map((el, i) => {
                          return (
                            <div
                              key={i}
                              className={`${
                                bg.includes(el.profile_name)
                                  ? "hidden"
                                  : "block"
                              } ${
                                likeDn.includes(el.profile_name)
                                  ? "hidden"
                                  : "block"
                              } custom-card cursor-pointer card-rounded-1 relative z-[444] rounded-[2.5rem] pb-2 min-w-0 w-full`}
                            >
                              {close.includes(el.profile_id) && (
                                <Lottie
                                  className="w-[100%] absolute top-[120px] right-[0px] z-[777]"
                                  key={i}
                                  animationData={DisLike}
                                  loop={true}
                                />
                              )}
                              {like.includes(el.profile_id) && (
                                <Lottie
                                  className="w-[100%] absolute top-[120px] right-[0px] z-[777]"
                                  key={i}
                                  animationData={Like}
                                  loop={true}
                                />
                              )}
                              <div
                                className={`${
                                  close?.includes(el?.profile_id) ||
                                  like?.includes(el?.profile_id)
                                    ? "opacity-0"
                                    : "opacity-[1]"
                                } duration-[0.7s] ease-in`}
                              >
                                <div className="position-relative rounded-[2.5rem] overflow-hidden shadow-md border border-gray-100/50">
                                  <div
                                    className="card-title"
                                    onClick={() =>
                                      IdHandler(
                                        i,
                                        el.profile_id,
                                        el.profile_name,
                                      )
                                    }
                                  >
                                    <div className="Coloreffect">
                                      {el?.profile_images.length > 1 ? (
                                        <Slider
                                          {...settings2}
                                          className="w-[100%]"
                                        >
                                          {el?.profile_images.map(
                                            (el, index) => {
                                              return (
                                                <div key={index}>
                                                  <img
                                                    className="img-fluid HEIGHT w-[100%] object-cover"
                                                    src={`${imageBaseURL}${el}`}
                                                    alt=""
                                                  />
                                                </div>
                                              );
                                            },
                                          )}
                                        </Slider>
                                      ) : (
                                        <img
                                          src={`${imageBaseURL}${el?.profile_images[0]}`}
                                          alt="img"
                                          className="img-fluid rounded-[2.5rem] BEFORE HEIGHT w-[100%] object-cover"
                                        />
                                      )}
                                    </div>
                                    <div className="card-content absolute bottom-[2rem] px-[15px] w-[100%] z-[2]">
                                      <div className="flex items-end justify-between gap-2">
                                        <h6 className="fw-semi-bold text-[18px] overflow-ellipsis overflow-hidden whitespace-nowrap mb-1 text-white">
                                          {el.profile_name}, {el.profile_age}
                                        </h6>
                                        <div className="">
                                          {el.is_subscribe === "0" ? (
                                            ""
                                          ) : (
                                            <div className="flex items-center gap-[10px]">
                                              <div className="bg-white p-[2px] rounded-full z-[555]">
                                                <img
                                                  src={Crown}
                                                  style={{
                                                    width: "20px",
                                                    height: "20px",
                                                  }}
                                                  alt="user-avatar"
                                                  className="bg-[rgba(152,14,255,255)] rounded-full p-[2px]"
                                                />
                                              </div>
                                              <h1 className="text-[15px] text-white font-[500] m-0">
                                                {t("Premium")}
                                              </h1>
                                            </div>
                                          )}
                                          <div className="relative flex items-center justify-center mt-[8px] mb-[8px]">
                                            <svg
                                              className="size-full w-[50px] -rotate-90"
                                              viewBox="0 0 36 36"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <circle
                                                cx="18"
                                                cy="18"
                                                r="16"
                                                fill="none"
                                                className="stroke-current text-[#fffdfd3f]"
                                                strokeWidth="3"
                                              ></circle>
                                              <circle
                                                cx="18"
                                                cy="18"
                                                r="16"
                                                fill="none"
                                                className="stroke-current text-white dark:text-white"
                                                strokeWidth="3"
                                                strokeDasharray="100"
                                                strokeDashoffset={`${100 - el.match_ratio.toFixed(0)}`}
                                                strokeLinecap="round"
                                              ></circle>
                                            </svg>
                                            <h6 className="m-0 absolute text-white text-[14px] p-[5px]">
                                              {el.match_ratio.toFixed(0)}%
                                            </h6>
                                          </div>
                                          <div className="KM whitespace-nowrap">
                                            <h6 className="m-0 flex items-center justify-center gap-[5px] text-white">
                                              <HiOutlineLocationMarker className="text-white text-[15px]" />
                                              {isPassportActive
                                                ? `${calculateDistanceKm(getLat(), getLong(), el.profile_lat || el.lats || el.lat, el.profile_longs || el.longs || el.long)} KM`
                                                : el.profile_distance}
                                            </h6>
                                          </div>
                                        </div>
                                      </div>
                                      <p className="mb-1 text-[19px] text-start mt-[5px] text-white overflow-ellipsis overflow-hidden whitespace-nowrap">
                                        {el.profile_bio === "undefined"
                                          ? ""
                                          : el.profile_bio}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                 <div className="-mt-[22px] z-[10] relative px-1">
                                   <div className="image-action-icon items-center cursor-default flex justify-center gap-1.5 sm:gap-2 flex-nowrap w-full">
                                     <button
                                       onClick={(e) => {
                                         e.stopPropagation();
                                         CloseAnimationHandler(
                                           el.profile_id,
                                           el.profile_name,
                                         );
                                       }}
                                       className="w-[42px] h-[42px] sm:w-[46px] sm:h-[46px] rounded-full bg-black flex items-center justify-center shadow-md transition-transform hover:scale-110 shrink-0"
                                       title="Dislike"
                                     >
                                       <RxCross2 className="w-[24px] h-[24px] text-yellow-400" />
                                     </button>
                                     <button
                                       onClick={(e) => {
                                         e.stopPropagation();
                                         LikeAnimationHandler(
                                           el.profile_id,
                                           el.profile_name,
                                         );
                                       }}
                                       className="w-[44px] h-[44px] sm:w-[48px] sm:h-[48px] rounded-full bg-black flex items-center justify-center shadow-md transition-transform hover:scale-110 shrink-0"
                                       title="Like"
                                     >
                                       <img
                                         src={HeartIcon}
                                         alt="Heart icon"
                                         className="w-[24px]"
                                       />
                                     </button>
                                     {isSuperLikeMasterEnabled && (
                                       <button
                                         onClick={(e) => {
                                           e.stopPropagation();
                                           SuperLikeAnimationHandler(
                                             el.profile_id,
                                             el.profile_name,
                                           );
                                         }}
                                         className="w-[44px] h-[44px] sm:w-[48px] sm:h-[48px] rounded-full bg-amber-500 flex items-center justify-center text-white text-lg shadow-md transition-transform hover:scale-110 shrink-0"
                                         title="Super Like"
                                       >
                                         <FaStar />
                                       </button>
                                     )}
                                     {isBoostMasterEnabled && (
                                       <button
                                         onClick={(e) => {
                                           e.stopPropagation();
                                           setEngagementInitialType("BOOST");
                                           setIsEngagementOpen(true);
                                         }}
                                         className="w-[44px] h-[44px] sm:w-[48px] sm:h-[48px] rounded-full bg-purple-600 flex items-center justify-center text-white text-lg shadow-md transition-transform hover:scale-110 shrink-0"
                                         title="Boost Profile"
                                       >
                                         <FaBolt />
                                       </button>
                                     )}
                                     <button
                                       onClick={(e) => {
                                         e.stopPropagation();
                                         ChatHandler(
                                           el.profile_id,
                                           el.profile_name,
                                         );
                                       }}
                                       className="w-[44px] h-[44px] sm:w-[48px] sm:h-[48px] rounded-full bg-black flex items-center justify-center shadow-md transition-transform hover:scale-110 shrink-0"
                                       title="Chat"
                                     >
                                       <img
                                         src={ChatIcon}
                                         alt="Chat icon"
                                         className="w-[24px]"
                                       />
                                     </button>
                                     <button
                                       className="w-[42px] h-[42px] sm:w-[46px] sm:h-[46px] rounded-full bg-black flex items-center justify-center shadow-md transition-transform hover:scale-110 shrink-0"
                                       onClick={(e) => {
                                         e.stopPropagation();
                                         setIsVisible(true);
                                         setGiftreceiverId(el.profile_id);
                                       }}
                                       title="Send Gift"
                                     >
                                       <img
                                         src={GiftIcon}
                                         alt="Gift icon"
                                         className="w-[24px]"
                                       />
                                     </button>
                                   </div>
                                 </div>
                              </div>
                            </div>
                          );
                        })}
                        {lazyLoading && (
                          <>
                            <ProfileCardSkeleton />
                            <ProfileCardSkeleton />
                            <ProfileCardSkeleton />
                            <ProfileCardSkeleton />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : hasActiveFilterData() ? (
          <div className="h-[100vh] ms-[16rem] max-_991_:ms-0 flex justify-center items-center">
            <div className="text-center">
              <h3>{t("No Any Match Profile...")}</h3>
              <button
                onClick={() => FilterResetHandler(1)}
                className="text-[18px] font-[600] mt-[20px] bg-[rgba(152,14,255,255)] text-white w-[50%] py-[10px] rounded-[10px]"
              >
                {t("Reset")}
              </button>
            </div>
          </div>
        ) : completionBlockMessage ? (
          <div className="h-[100vh] ms-[16rem] max-_991_:ms-0 flex justify-center items-center">
            <div className="text-center px-4">
              <h3>{t("Complete your profile")}</h3>
              <p className="mt-2 mb-3">{completionBlockMessage}</p>
              <button
                onClick={() => navigate("/profile")}
                className="btn text-white"
                style={{ background: "rgb(152, 14, 255)" }}
              >
                {t("Update Profile")}
              </button>
            </div>
          </div>
        ) : (
          <div className="h-[100vh] ms-[16rem] max-_991_:ms-0 flex justify-center items-center">
            <h3>{t("No Any New Profile...")}</h3>
          </div>
        )}

        {loading && (
          <div className="w-[100%] h-[100vh] ms-[8rem] max-_991_:ms-0 bg-white fixed flex items-center justify-center top-0 left-0 right-0 bottom-0 z-[555]">
            <LodingLottie
              ClassCss={
                "w-[20%] max-_430_:w-[100%] max-_770_:w-[50%] max-_1030_:w-[40%] max-_1145_:w-[30%] max-_1200_:w-[30%] max-_1300_:w-[30%]"
              }
            />
          </div>
        )}

        <div ref={Classadd} className="filter-area flex flex-col h-full max-h-screen overflow-hidden bg-white shadow-2xl z-[9999]" style={{ display: 'flex', flexDirection: 'column', height: '100vh', maxHeight: '100vh', overflow: 'hidden' }}>
          {/* Header */}
          <div className="filter-heading shrink-0 flex justify-between items-center px-5 py-4 border-b border-gray-200 bg-white" style={{ flexShrink: 0 }}>
            <h3 className="fw-semi-bold text-[18px] font-[600] text-gray-900 mb-0">{t("Filter & Show")}</h3>
            <button
              onClick={FilterHandler}
              type="button"
              className="w-[32px] h-[32px] rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-600 transition-colors"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>

          {/* Scrollable Content Body */}
          <div className="filter-content flex-1 overflow-y-auto min-h-0 px-5 py-4 space-y-4" style={{ flex: '1 1 auto', overflowY: 'auto', minHeight: 0 }}>
            <div className="filter-element border-b pb-2 mb-2 border-gray-200">
              <div className="">
                <div className="flex justify-between items-center mb-1">
                  <h6 className="text-[15px] font-[600] text-gray-900 m-0">
                    {t("Distance Range")}
                  </h6>
                  <span className="text-[13px] font-[500] text-purple-700">
                    {Number(distance).toFixed(2)} {distanceSettings.distanceUnit.toLowerCase()}
                  </span>
                </div>
                <input
                  style={sliderStyle}
                  type="range"
                  className="Range my-1"
                  min={distanceSettings.minDistance}
                  max={distanceSettings.maxDistance}
                  step="1"
                  value={distance}
                  onChange={(e) => setDistance(Number(e.target.value))}
                />
                <div className="flex justify-between text-[12px] text-gray-400 mt-[2px]">
                  <span>{distanceSettings.minDistance} {distanceSettings.distanceUnit.toLowerCase()}</span>
                  <span>{distanceSettings.maxDistance} {distanceSettings.distanceUnit.toLowerCase()}</span>
                </div>
              </div>
            </div>

            <div className="filter-element border-b pb-2 mb-2 border-gray-200">
              <div
                key="age-range-slider-fixed"
                className="range-slider relative w-full mb-1"
                data-role="rangeslider"
              >
                <div className="range-label mb-2 flex justify-between items-center">
                  <label className="form-label font-[600] text-[15px] text-gray-900 m-0">{t("Age")}</label>
                  <span id="range-value" className="form-label font-[500] text-[13px] text-purple-700 m-0">
                    {AGEMIN}-{AGEMAX}
                  </span>
                </div>

                <div className="relative w-full h-[24px] flex items-center">
                  <div
                    style={{
                      background: `linear-gradient(to right, rgba(199, 197, 197, 0.8) 0%, rgba(199, 197, 197, 0.8) ${minGradientPos}, rgba(152, 14, 255, 1) ${minGradientPos}, rgba(152, 14, 255, 1) ${maxGradientPos}, rgba(199, 197, 197, 0.8) ${maxGradientPos}, rgba(199, 197, 197, 0.8) 100%)`
                    }}
                    className="track absolute w-full top-[9px] h-[5px] rounded-full pointer-events-none"
                  ></div>

                  <input
                    type="range"
                    name="ageMin"
                    id="ageMin"
                    value={currentMinAge}
                    onChange={(e) => {
                      const min = Number(e.target.value);
                      setAgemin(min);
                      if (min > currentMaxAge) {
                        setAgemax(min);
                      }
                    }}
                    min={MIN_AGE}
                    max={MAX_AGE}
                    className="absolute border-0 form-input-range top-0 w-full"
                    style={{ zIndex: currentMinAge > (MIN_AGE + MAX_AGE) / 2 ? 5 : 4 }}
                  />

                  <input
                    type="range"
                    name="ageMax"
                    id="ageMax"
                    value={currentMaxAge}
                    onChange={(e) => {
                      const max = Number(e.target.value);
                      setAgemax(max);
                      if (max < currentMinAge) {
                        setAgemin(max);
                      }
                    }}
                    min={MIN_AGE}
                    max={MAX_AGE}
                    className="absolute border-0 form-input-range top-0 w-full"
                    style={{ zIndex: currentMinAge > (MIN_AGE + MAX_AGE) / 2 ? 4 : 5 }}
                  />
                </div>
              </div>
            </div>

            <div className="filter-element border-b pb-2 mb-2 border-gray-200">
              <h6 className="text-[15px] font-[600] text-gray-900 mb-1.5">
                {t("Serach Preference")}
              </h6>
              <div className="flex flex-wrap items-center gap-1.5">
                {searchPreferenceOptions.map((option) => (
                  <button
                    key={option.value}
                    type="button"
                    onClick={() => setPreference(option.value)}
                    className={`text-[13px] font-[400] inline-flex items-center border-[1.5px] border-gray-300 rounded-full py-[4px] px-[12px] cursor-pointer transition-all ${
                      preference === option.value ? "Active selected bg-[#980EFF] text-white border-[#980EFF] font-semibold" : "hover:bg-gray-100 text-gray-700"
                    }`}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="filter-element border-b pb-2 mb-2 border-gray-200">
              <h6 className="text-[15px] font-[600] text-gray-900 mb-1.5">
                {t("Interests")}
              </h6>
              <div className="flex flex-wrap items-center gap-1.5">
                {interestList.map((el, index) => {
                  const isSelected = interestId.includes(el.id);
                  return (
                    <button
                      key={index}
                      type="button"
                      onClick={() => InterestMapHandler(el.id)}
                      className={`text-[13px] font-[400] inline-flex items-center gap-[5px] border-[1.5px] border-gray-300 rounded-full py-[4px] px-[12px] cursor-pointer transition-all ${
                        isSelected ? "Active selected bg-[#980EFF] text-white border-[#980EFF] font-semibold" : "hover:bg-gray-100 text-gray-700"
                      }`}
                    >
                      <span>{t(el.title)}</span>
                      <img
                        src={imageBaseURL + el.img}
                        alt=""
                        className="w-[16px] h-[16px] object-contain"
                      />
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="filter-element border-b pb-2 mb-2 border-gray-200">
              <h6 className="text-[15px] font-[600] text-gray-900 mb-1.5">
                {t("Langusges I Know")}
              </h6>
              <div className="flex flex-wrap items-center gap-1.5">
                {languageList.map((el, index) => {
                  const isSelected = language.includes(el.id);
                  return (
                    <button
                      key={index}
                      type="button"
                      onClick={() => LanguageMapHandler(el.id)}
                      className={`text-[13px] font-[400] inline-flex items-center border-[1.5px] border-gray-300 rounded-full py-[4px] px-[12px] cursor-pointer transition-all ${
                        isSelected ? "Active selected bg-[#980EFF] text-white border-[#980EFF] font-semibold" : "hover:bg-gray-100 text-gray-700"
                      }`}
                    >
                      {t(el.title)}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="filter-element border-b pb-2 mb-2 border-gray-200">
              <h6 className="text-[15px] font-[600] text-gray-900 mb-1.5">
                {t("Religion")}
              </h6>
              <div className="flex flex-wrap items-center gap-1.5">
                {religionList.map((el, index) => {
                  const isSelected = religion === index;
                  return (
                    <button
                      key={index}
                      type="button"
                      onClick={() => setReligion(index)}
                      className={`text-[13px] font-[400] inline-flex items-center border-[1.5px] border-gray-300 rounded-full py-[4px] px-[12px] cursor-pointer transition-all ${
                        isSelected ? "Active selected bg-[#980EFF] text-white border-[#980EFF] font-semibold" : "hover:bg-gray-100 text-gray-700"
                      }`}
                    >
                      {t(el.title)}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="filter-element border-b pb-2 mb-2 border-gray-200">
              <h6 className="text-[15px] font-[600] text-gray-900 mb-1.5">
                {t("Relationship Goals")}
              </h6>
              <div className="flex flex-wrap items-center gap-1.5">
                {relationshipList.map((el, index) => {
                  const isSelected = relationship === index;
                  return (
                    <button
                      key={index}
                      type="button"
                      onClick={() => setRelationship(index)}
                      className={`text-[13px] font-[400] inline-flex items-center border-[1.5px] border-gray-300 rounded-full py-[4px] px-[12px] cursor-pointer transition-all ${
                        isSelected ? "Active selected bg-[#980EFF] text-white border-[#980EFF] font-semibold" : "hover:bg-gray-100 text-gray-700"
                      }`}
                    >
                      {t(el.title)}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="filter-element pb-2 mb-2">
              <h6 className="text-[15px] font-[600] text-gray-900 mb-1.5">
                {t("Verify Profile")}
              </h6>
              <div className="flex flex-wrap items-center gap-1.5">
                <button
                  type="button"
                  onClick={() => setVerify("0")}
                  className={`text-[13px] font-[400] inline-flex items-center border-[1.5px] border-gray-300 rounded-full py-[4px] px-[12px] cursor-pointer transition-all ${
                    verify === "0" ? "Active selected bg-[#980EFF] text-white border-[#980EFF] font-semibold" : "hover:bg-gray-100 text-gray-700"
                  }`}
                >
                  {t("Unverify")}
                </button>
                <button
                  type="button"
                  onClick={() => setVerify("2")}
                  className={`text-[13px] font-[400] inline-flex items-center border-[1.5px] border-gray-300 rounded-full py-[4px] px-[12px] cursor-pointer transition-all ${
                    verify === "2" ? "Active selected bg-[#980EFF] text-white border-[#980EFF] font-semibold" : "hover:bg-gray-100 text-gray-700"
                  }`}
                >
                  {t("Verify")}
                </button>
              </div>
            </div>
          </div>

          {/* Fixed Footer Buttons */}
          <div className="filter-footer shrink-0 bg-white border-t border-gray-200 px-5 py-3.5 flex justify-between items-center gap-3 shadow-[0_-4px_16px_rgba(0,0,0,0.06)]" style={{ flexShrink: 0 }}>
            <button
              onClick={FilterResetHandler}
              type="button"
              className="text-[15px] font-[600] text-[rgba(152,14,255,255)] bg-[#c67aff33] hover:bg-[#c67aff55] flex-1 py-2.5 rounded-[12px] transition-colors text-center"
            >
              {t("Reset")}
            </button>
            <button
              onClick={FilterApplyHandler}
              type="button"
              className="text-[15px] font-[600] bg-[rgba(152,14,255,255)] hover:bg-[#8600e6] text-white flex-1 py-2.5 rounded-[12px] transition-colors shadow-md text-center"
            >
              {t("Apply")}
            </button>
          </div>
        </div>

        {/* <!-- Overlay Start --> */}
        <div
          ref={BgDisplay}
          onClick={FilterHandler}
          id="overlay"
          className="overlay z-[888]"
        ></div>
        {/* <!-- Overlay End --> */}

        {/* <!-- Scroll To Top Start --> */}
        <button className="scroll-to-top block">
          <svg
            width="16"
            height="10"
            viewBox="0 0 16 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.408 1.23077L14.9362 12.3077C15.1175 12.6154 14.8908 13 14.5282 13H1.47184C1.10916 13 0.882484 12.6154 1.06382 12.3077L7.59199 1.23077C7.77333 0.923077 8.22667 0.923077 8.408 1.23077Z"
              stroke="var(--primary-color)"
              strokeWidth="2"
            />
          </svg>
        </button>

        {/* Gift Model */}
        <GiftModal
          isVisible={isVisible}
          onClose={() => setIsVisible(false)}
          receiverId={giftReceiverId}
        />

        {/* Engagement Modal (Super Likes & Boosts) */}
        <EngagementModal
          isOpen={isEngagementOpen}
          onClose={() => setIsEngagementOpen(false)}
          baseUrl={basUrl}
          initialType={engagementInitialType}
        />
      </div>
    </>
  );
};

export default Dashboard;
/* jshint ignore:end */
